import { css, Global } from '@emotion/react'

export default function GlobalStyles() {
  return (
    <Global
      styles={css`
        *,
        *::before,
        *::after {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          outline: none;
          -webkit-tap-highlight-color: transparent;
        }

        :root {
          --safe-bottom: env(safe-area-inset-bottom, 0px);
        }

        html,
        body {
          width: 100%;
          height: auto;
          overflow: hidden;
          overscroll-behavior: none;
          background: #1b1c1d;
        }

        #root {
          width: 100%;
          max-width: 480px;
          height: 100dvh;
          margin: 0 auto;
          overflow-y: auto;
          overscroll-behavior: none;
          -webkit-overflow-scrolling: touch;
          background: #ffffff;
          border: none;
        }

        body {
          font-size: 16px;
          font-family:
            'Pretendard Variable',
            Pretendard,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          -webkit-tap-highlight-color: transparent;
          -webkit-text-size-adjust: 100%;
          user-select: none;
          touch-action: manipulation;
        }

        button {
          cursor: pointer;
          border: none;
          background: none;
          font-family: inherit;
        }
      `}
    />
  )
}
